import * as React from "react";
const DashBoardIcon = (props) => (
  <svg
    width={33}
    height={32}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.4}>
      <path
        d="M22.0865 2.6665H10.9132C6.05984 2.6665 3.1665 5.55984 3.1665 10.4132V21.5732C3.1665 26.4398 6.05984 29.3332 10.9132 29.3332H22.0732C26.9265 29.3332 29.8198 26.4398 29.8198 21.5865V10.4132C29.8332 5.55984 26.9398 2.6665 22.0865 2.6665Z"
        fill="#292D32"
      />
      <path
        d="M22.0865 2.6665H10.9132C6.05984 2.6665 3.1665 5.55984 3.1665 10.4132V21.5732C3.1665 26.4398 6.05984 29.3332 10.9132 29.3332H22.0732C26.9265 29.3332 29.8198 26.4398 29.8198 21.5865V10.4132C29.8332 5.55984 26.9398 2.6665 22.0865 2.6665Z"
        fill="url(#paint0_linear_3639_300877)"
      />
    </g>
    <path
      d="M9.67334 25.1999C9.12667 25.1999 8.67334 24.7466 8.67334 24.1999V21.4399C8.67334 20.8933 9.12667 20.4399 9.67334 20.4399C10.22 20.4399 10.6733 20.8933 10.6733 21.4399V24.1999C10.6733 24.7599 10.22 25.1999 9.67334 25.1999Z"
      fill="#292D32"
    />
    <path
      d="M9.67334 25.1999C9.12667 25.1999 8.67334 24.7466 8.67334 24.1999V21.4399C8.67334 20.8933 9.12667 20.4399 9.67334 20.4399C10.22 20.4399 10.6733 20.8933 10.6733 21.4399V24.1999C10.6733 24.7599 10.22 25.1999 9.67334 25.1999Z"
      fill="url(#paint1_linear_3639_300877)"
    />
    <path
      d="M16.5 25.1998C15.9533 25.1998 15.5 24.7465 15.5 24.1998V18.6665C15.5 18.1198 15.9533 17.6665 16.5 17.6665C17.0467 17.6665 17.5 18.1198 17.5 18.6665V24.1998C17.5 24.7598 17.0467 25.1998 16.5 25.1998Z"
      fill="#292D32"
    />
    <path
      d="M16.5 25.1998C15.9533 25.1998 15.5 24.7465 15.5 24.1998V18.6665C15.5 18.1198 15.9533 17.6665 16.5 17.6665C17.0467 17.6665 17.5 18.1198 17.5 18.6665V24.1998C17.5 24.7598 17.0467 25.1998 16.5 25.1998Z"
      fill="url(#paint2_linear_3639_300877)"
    />
    <path
      d="M23.3267 25.2001C22.78 25.2001 22.3267 24.7467 22.3267 24.2001V15.9067C22.3267 15.3601 22.78 14.9067 23.3267 14.9067C23.8733 14.9067 24.3267 15.3601 24.3267 15.9067V24.2001C24.3267 24.7601 23.8867 25.2001 23.3267 25.2001Z"
      fill="#292D32"
    />
    <path
      d="M23.3267 25.2001C22.78 25.2001 22.3267 24.7467 22.3267 24.2001V15.9067C22.3267 15.3601 22.78 14.9067 23.3267 14.9067C23.8733 14.9067 24.3267 15.3601 24.3267 15.9067V24.2001C24.3267 24.7601 23.8867 25.2001 23.3267 25.2001Z"
      fill="url(#paint3_linear_3639_300877)"
    />
    <path
      d="M24.3265 7.75981C24.3265 7.69314 24.2998 7.61314 24.2865 7.54647C24.2731 7.49314 24.2598 7.42647 24.2465 7.37314C24.2198 7.31981 24.1798 7.2798 24.1531 7.22647C24.1131 7.17314 24.0731 7.10647 24.0198 7.06647C24.0065 7.05314 24.0065 7.03981 23.9931 7.03981C23.9531 7.01314 23.9131 6.9998 23.8731 6.97314C23.8198 6.93314 23.7531 6.89314 23.6865 6.86647C23.6198 6.8398 23.5531 6.8398 23.4865 6.82647C23.4331 6.81314 23.3931 6.7998 23.3398 6.7998H19.4331C18.8865 6.7998 18.4331 7.25314 18.4331 7.7998C18.4331 8.34647 18.8865 8.7998 19.4331 8.7998H21.0998C17.9265 12.1331 13.9265 14.4798 9.43314 15.6131C8.89981 15.7465 8.56648 16.2931 8.69981 16.8265C8.80648 17.2798 9.21981 17.5865 9.67314 17.5865C9.75314 17.5865 9.83314 17.5731 9.91314 17.5598C14.6731 16.3731 18.9265 13.9065 22.3265 10.4131V11.7065C22.3265 12.2531 22.7798 12.7065 23.3265 12.7065C23.8731 12.7065 24.3265 12.2531 24.3265 11.7065V7.7998C24.3265 7.78647 24.3265 7.77314 24.3265 7.75981Z"
      fill="#292D32"
    />
    <path
      d="M24.3265 7.75981C24.3265 7.69314 24.2998 7.61314 24.2865 7.54647C24.2731 7.49314 24.2598 7.42647 24.2465 7.37314C24.2198 7.31981 24.1798 7.2798 24.1531 7.22647C24.1131 7.17314 24.0731 7.10647 24.0198 7.06647C24.0065 7.05314 24.0065 7.03981 23.9931 7.03981C23.9531 7.01314 23.9131 6.9998 23.8731 6.97314C23.8198 6.93314 23.7531 6.89314 23.6865 6.86647C23.6198 6.8398 23.5531 6.8398 23.4865 6.82647C23.4331 6.81314 23.3931 6.7998 23.3398 6.7998H19.4331C18.8865 6.7998 18.4331 7.25314 18.4331 7.7998C18.4331 8.34647 18.8865 8.7998 19.4331 8.7998H21.0998C17.9265 12.1331 13.9265 14.4798 9.43314 15.6131C8.89981 15.7465 8.56648 16.2931 8.69981 16.8265C8.80648 17.2798 9.21981 17.5865 9.67314 17.5865C9.75314 17.5865 9.83314 17.5731 9.91314 17.5598C14.6731 16.3731 18.9265 13.9065 22.3265 10.4131V11.7065C22.3265 12.2531 22.7798 12.7065 23.3265 12.7065C23.8731 12.7065 24.3265 12.2531 24.3265 11.7065V7.7998C24.3265 7.78647 24.3265 7.77314 24.3265 7.75981Z"
      fill="url(#paint4_linear_3639_300877)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3639_300877"
        x1={29.8199}
        y1={2.6665}
        x2={3.1665}
        y2={2.6665}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#74EBD5" />
        <stop offset={1} stopColor="#9FACE6" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3639_300877"
        x1={10.6733}
        y1={20.4399}
        x2={8.67334}
        y2={20.4399}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#74EBD5" />
        <stop offset={1} stopColor="#9FACE6" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3639_300877"
        x1={17.5}
        y1={17.6665}
        x2={15.5}
        y2={17.6665}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#74EBD5" />
        <stop offset={1} stopColor="#9FACE6" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3639_300877"
        x1={24.3267}
        y1={14.9067}
        x2={22.3267}
        y2={14.9067}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#74EBD5" />
        <stop offset={1} stopColor="#9FACE6" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3639_300877"
        x1={24.3265}
        y1={6.7998}
        x2={8.67041}
        y2={6.7998}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#74EBD5" />
        <stop offset={1} stopColor="#9FACE6" />
      </linearGradient>
    </defs>
  </svg>
);
export default DashBoardIcon;
